import { AfterContentInit, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { environment } from '../../../../environments/environment';
// import {Tab} from './tab';
import { Tab } from '../tab/tab.component';

@Component({
    selector: 'tabs',
    styles: [`
            a {
                cursor: pointer;
            }
            
            .btn {
                    border: none;
                    outline: none;
                    padding: 10px 16px;
                    background-color: #f1f1f1;
                    cursor: pointer;
                    font-size: 18px;
                }
                .active, .btn:hover {
                    background-color: #666;
                    color: white;
                }
        `],
    template: `
        <ul [ngClass]="selectedTabsLook">
            <li
                    *ngFor="let tab of tabs"
                    (click)="selectTab(tab)"
                    [class.active]="tab.active"
                    [ngClass]="selectedTabStyle"
             >
                <a>
                    {{tab.title}}
                </a>
            </li>
        </ul>
        <ng-content></ng-content>
    `
})
export class Tabs implements AfterContentInit {
    public selectedTab: boolean = false;
    public selectedTabsLook: string = 'nav nav-pills';
    public selectedTabStyle: string;
    @Input('tabsLook') tabsLook: string;
    @ContentChildren(Tab) tabs: QueryList<Tab>;

    // contentChildren are set
    ngAfterContentInit() {
        // get all active tabs
        const activeTabs = this.tabs.filter((tab) => tab.active);

        // if there is no active tab set, activate the first
        if (activeTabs.length === 0) {
            this.selectTab(this.tabs.first);
        }
        // Define tabs look
        if (this.tabsLook === 'defaultTabs') {
            this.selectedTabsLook = 'nav nav-tabs';
            this.selectedTabStyle = this.selectedTab ? 'active nav-link' : 'nav-link';
        } else if (this.tabsLook === 'tcmTabs') {
            this.selectedTabsLook = 'nav nav-pills';
            this.selectedTabStyle = this.selectedTab ? 'active btn' : 'btn';
        }
    }

    selectTab(tab: Tab) {
        // deactivate all tabs
        this.tabs.toArray().forEach(tab => tab.active = false);
        // activate the tab the user has clicked on.
        tab.active = true;
        this.selectedTab = true;

        if (tab.title === 'Create Account') {
            (<any>window).gtag('config', environment.gaId, { 'page_path': `/registration` });
        } else if (tab.title === 'Existing User') {
            (<any>window).gtag('config', environment.gaId, { 'page_path': `/login` });
        }

        // [ngStyle]="selectedTab ? '' : {'background-color': c8c8c8}"
    }
}



// WEBPACK FOOTER //
// ./public/app/common/tabs/tabs/tabs.component.ts